import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';
import { DatabaseIndice, DatabaseRelation } from '../alcance/interfaces/database';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class EquipamentoDBService extends DatabaseService {
    override classname: string = 'EquipamentoDBService';
    override table = 'equipamento';
    override keyPath = 'uuid';
    override typeKey = 'TEXT';
    protected override useUuidKey = true;

    override indices: DatabaseIndice[] = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_edificacao", field: "edificacao_id", unique: false, multiEntry: false },
        { name: "by_descricao", field: "descricao", unique: false, multiEntry: false },
        { name: "by_controle", field: "controle", unique: false, multiEntry: false },
        { name: "by_categoria", field: "categoria_id", unique: false, multiEntry: false },
        { name: "by_validade", field: "dt_validade", unique: false, multiEntry: false },
        { name: "by_sinc", field: "sinc", unique: false, multiEntry: false },
        { name: "by_tipo", field: "tipo_id", unique: false, multiEntry: false },
        { name: "by_tipos", field: "tipos.id", unique: false, multiEntry: true }
    ];

    //MIGRACOES DE DADOS
    protected override migration = 5;

    protected override relations: DatabaseRelation[] = [
        // {name: 'edificacao', table: 'edificacao', field: 'edificacao_id', type: 'foreign'}, // só deixa lento, e o app não usa ja pega do usuario
        {name: 'andar', table: 'andar', field: 'andar_id', type: 'foreign'},
    ];

    protected override collectObj(obj: any) {
        obj.dt_validade = obj.dt_validade ? (moment as any)(obj.dt_validade).format('YYYY-MM-DD') : null;
        return super.collectObj(obj);
    }

    protected override filterSql(sql: string, params: any): string {
        if(params?.descricao){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_descricao LIKE '%" + params.descricao + "%'";
        }
        if(params?.controle){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_controle LIKE '" + params.controle + "'";
        }
        if(params?.categoria_id){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_categoria = '" + params.categoria_id + "'";
        }
        if(params?.tipo_id){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            const tipoId = params.tipo_id;
            sql += " (by_tipo = '" + tipoId + "' OR EXISTS (SELECT 1 FROM equipamento_by_tipos multi_entry WHERE multi_entry.foreign_uuid = equipamento.uuid AND multi_entry.by_tipos = '" + tipoId + "'))";
        }
        if(params?.dt_validade){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_validade = '" + (moment as any)(params.dt_validade).format('YYYY-MM-DD') + "'";
        }

        return sql;
    }
}
